import { Controller } from "@hotwired/stimulus";

// Disables the submit button once the login form is submitted so rage-clicks
// can't fire a burst of POSTs. The login layout sets data-turbo="false", so
// Turbo's automatic disabled state never kicks in and nothing stopped the
// button from being clicked repeatedly — the exact behaviour behind the
// /login rage-click bursts, which also burn through the rack-attack budget of
// 5 POSTs / 20s.
//
// The disable is deferred to the next tick: disabling a submit control inside
// its own submit event cancels the in-flight submission in some browsers, so
// we let the browser start the POST first.
export default class extends Controller {
  static targets = ["button"];

  lock() {
    setTimeout(() => {
      this.buttonTargets.forEach((button) => {
        button.disabled = true;
        button.classList.add("loading", "disabled");
        if (button.value) {
          button.value = "Signing in…";
        }
      });
    }, 0);
  }
}
